import { GridColDef } from "@mui/x-data-grid";
import BigNumber from "bignumber.js";
import { useTranslation } from "src/hooks";
import { useGenGridCol } from "src/utils/HelperComp";

function useSwapApprovalTable() {
  const { t } = useTranslation("assetManagement");

  const displayAmountToBigNum = (amount: string) => {
    const amountWithoutCurrency = amount.split(" ")[0]; // Remove currency symbol

    return new BigNumber(amountWithoutCurrency.replace(/,/g, "")); // Remove commas for thousands
  };

  const sortDisplayAmount = (v1: string, v2: string) => {
    return displayAmountToBigNum(v1)
      .minus(displayAmountToBigNum(v2))
      .toNumber();
  };

  const columns: GridColDef<{
    operation_seq: number | string;
    wallet_address: string;
    swap_execution_type: string;
    pay_currency: string;
    pay_total_amount: string;
    get_currency: string;
    get_total_amount: string;
  }>[] = [
    useGenGridCol("operation_seq", "#", {
      // renderHeader: headerCellID,
      minWidth: 45,
      headerAlign: "right",
      align: "right",
    }),
    useGenGridCol("wallet_address", t("wallet_address"), {
      minWidth: 350,
      headerAlign: "left",
      align: "left",
    }),
    useGenGridCol("swap_execution_type", t("swap_execution_type"), {
      minWidth: 120,
      align: "center",
    }),
    useGenGridCol("pay_currency", t("pay_currency"), {
      minWidth: 120,
      align: "right",
    }),
    useGenGridCol("pay_total_amount", t("pay_total_amount"), {
      sortable: true,
      minWidth: 150,
      align: "right",
      sortComparator: sortDisplayAmount,
    }),
    useGenGridCol("get_currency", t("get_currency"), {
      minWidth: 120,
      align: "right",
    }),
    useGenGridCol("get_total_amount", t("get_total_amount"), {
      minWidth: 150,
      sortable: true,
      align: "right",
      sortComparator: sortDisplayAmount,
    }),
  ];

  return { columns };
}

export default useSwapApprovalTable;
